import { useMutation } from '@tanstack/react-query';
import { RepositoryClient } from '../httpClients/RepositoryClient';
import { BitbucketInstallWebhooksRequest } from '../httpClients/RepositoryClient/api.schema';
import { MUTATION_KEYS } from './consts';

export const useBitbucketInstallWebhooksMutation = () =>
  useMutation({
    mutationKey: [MUTATION_KEYS.BITBUCKET_INSTALL_WEBHOOKS],
    mutationFn: async (payload: BitbucketInstallWebhooksRequest) =>
      RepositoryClient.bitbucketInstallWebhooks(payload),
  });
